/**名前一覧 */
export class UseResultsInfo {
  companyNo: string;

  customerNo: string;
  reserveNo: string;
  arrivalDate: string;
  departureDate: string;
  useAmount: number;

  status: string;
  version: number;
  creator: string;
  updator: string;
  cdt: string;
  udt: string;

  displayArrivalDate: string;
  displayDepartureDate: string;
}
